<template>
  <el-dialog
    :visible.sync="DialogShow"
    @closed="closeDialog"
    @open="openDialog"
    append-to-body
    width="60%"
    custom-class="import-dialog"
    top="5vh"
    :close-on-click-modal="false"
  >
    <div slot="title" class="dialog-title">
      <span class="title-line"></span>
      <span class="title-text">{{ title }}</span>
    </div>
    <el-form
      :model="submitFormData"
      :rules="rules"
      ref="form"
      label-width="130px"
    >
      <el-form-item label="条约名称" prop="termName">
        <el-input
          placeholder="请输入条约名称"
          v-model="submitFormData.termName"
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="条约内容">
        <tinymce
          ref="tinymceRef"
          :width="900"
          :height="500"
          v-model="submitFormData.termContent"
        ></tinymce>
      </el-form-item>
      <div class="from-btn-wrap">
        <el-button type="primary" @click="handelClickFirstSubmit" size="small">
          保存
        </el-button>
        <el-button type="primary" plain size="small" @click="handelClickCancel"
          >取消</el-button
        >
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import { clone } from '@/utils/utils';
import Tinymce from '@/components/Tinymce';
import { create, update, getByBid } from '@/api/userProtocolPrivacy';
const defaultUpdataObj = {
  termName: '',
  termContent: '',
  visaTermBid: '',
  termType: 1,
};
export default {
  data() {
    return {
      token: '',
      editableTabsValue: 'first',
      active: 1,
      upDataMsg: '保存',
      submitFormData: Object.assign({}, defaultUpdataObj), //
      rules: {
        termName: [
          { required: true, message: '请输入名称', trigger: 'change' },
        ],
      }, //  hasElectronicForm: '',
      // electronicFormBid: '',
      DialogShow: false,
      countryList: [],
      visaTypeList: [],
      consularList: [],
      entriesList: [],
      applicantList: [],
      visaPictureUrl: '',
      imgType: '',
      informationList: [],
      setItemIconInx: null,
      electronList: [],
    };
  },
  props: {
    title: {
      type: String,
      default: function () {
        return '';
      },
    },
    termBid: {
      type: String,
      default: '',
    },
  },
  methods: {
    openDialog() {
      console.log(123, this.termBid);
      if (this.termBid) {
        getByBid(this.termBid).then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.submitFormData = Object.assign({}, res.data);
            console.log(this.submitFormData);
          }
        });
      } else {
        this.submitFormData = Object.assign({}, defaultUpdataObj);
      }
    },
    handelClickFirstSubmit() {
      if (!this.termBid) {
        create(this.submitFormData).then((res) => {
          if (res.code == 200) {
            this.$msg.success('保存成功！');
            this.$emit('upData');
            this.closeDialog();
          }
        });
        this.upDataMsg = '保存';
      } else {
        this.submitFormData.visaTermBid = this.termBid;
        update(this.submitFormData).then((res) => {
          if (res.code == 200) {
            this.$msg.success('保存成功！');
            this.$emit('upData');
            this.closeDialog();
          }
        });
        this.upDataMsg = '保存';
      }
    },

    handelClickCancel() {
      this.closeDialog();
    },
    closeDialog() {
      // this.editableTabsValue = 'first';
      this.submitFormData = Object.assign({}, defaultUpdataObj);
      // this.$refs.form.resetFields();
      // this.$refs.tinymceRef.$destroy();
      this.DialogShow = false;
    },
  },
  components: {
    Tinymce,
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog.import-dialog {
  height: auto;
  max-height: 90vh;
  overflow-y: auto;
}
//弹出层里内容的高度
::v-deep .el-dialog__body {
  max-height: 85vh !important;
}

::v-deep .el-tabs__header {
  display: none;
}
::v-deep .el-steps {
  margin-bottom: 20px;
}
::v-deep .el-tabs__content {
  width: 94%;
  //   padding: 30px 40px 30px 20px;
}
::v-deep .el-step__icon.is-text {
  width: 40px;
  height: 40px;
}
::v-deep .el-step.is-horizontal .el-step__line {
  top: 19px;
  width: 266px;
  left: 67px;
}
.el-select {
  width: 90%;
}
.avatar {
  width: 70px;
  height: 54px;
}
.add-identity {
  .el-button {
    margin-left: 110px;
  }
}
.instruction-desc {
  .el-input {
    width: 500px;
  }
  .el-button--small {
    padding: 9px;
    margin: 0 5px;
  }
}
.border-wrap {
  border-bottom: 1px #666 solid;
  margin-bottom: 20px;
}
</style>